import { gql } from '@apollo/client';

export const UPDATE_TMS_TRANSIT_ROUTE_STATUS = gql`
    mutation UpdateTmsTransitRouteStatus($id: String!, $status: Int!) {
        updateTmsTransitRouteStatus(id: $id, status: $status)
    }
`;

export interface UpdateTmsTransitRouteStatusResponse {
    updateTmsTransitRouteStatus: boolean;
}
